import Component from 'flarum/common/Component';
/**
 * AvocadoDiscussionStats — compact stats card injected between the Reply
 * button (@100) and the Scrubber/Timeline (@-100) in the DiscussionPage sidebar.
 *
 * Shows: views (flarum/views), replies, and first-post likes (flarum/likes).
 */
export default class AvocadoDiscussionStats extends Component {
  view() {
    const {
      discussion
    } = this.attrs;
    if (!discussion) return m("div", {
      className: "AvocadoSidebar-stats"
    });
    const replyCount = Number(discussion.replyCount?.()) || 0;
    const viewCount = Number(discussion.attribute?.('viewCount') ?? discussion.viewCount?.() ?? 0);
    const firstPost = discussion.firstPost?.();
    const likeCount = Number(firstPost?.attribute?.('likesCount') ?? firstPost?.likesCount?.() ?? 0);
    const rows = [viewCount > 0 && {
      key: 'views',
      icon: 'far fa-eye',
      label: 'Views',
      value: viewCount.toLocaleString()
    }, true && {
      key: 'replies',
      icon: 'far fa-comment',
      label: 'Replies',
      value: String(replyCount)
    }, likeCount > 0 && {
      key: 'likes',
      icon: 'far fa-thumbs-up',
      label: 'Likes',
      value: String(likeCount)
    }].filter(Boolean);
    return m("div", {
      className: "AvocadoSidebar-stats"
    }, rows.map(_ref => {
      let {
        key,
        icon,
        label,
        value
      } = _ref;
      return m("div", {
        key: key,
        className: "AvocadoSidebar-statRow"
      }, m("span", {
        className: "AvocadoSidebar-statLabel"
      }, m("i", {
        className: icon,
        "aria-hidden": "true"
      }), label), m("span", {
        className: "AvocadoSidebar-statValue"
      }, value));
    }));
  }
}
flarum.reg.add('ramon-avocado', 'forum/components/AvocadoDiscussionStats', AvocadoDiscussionStats);